import { GlobalNavLinkProps, GlobalNavProps } from '@stadionhq-v3/base-ui';
import { SiteSettings } from '@graphql/index';
import { Locale } from '@core/constants/locales.constants';
import { isRtlLocale } from '@utils/locales.utils/locales.utils';
import { CleanContentful } from '@stadionhq-v3/clean-contentful';
import { ArrowLeft, ArrowRight, Bento } from '@components/icons';
import { linkTransform } from '../atoms';

export const globalNavTransform = (
  { headerOtherSiteLinks }: CleanContentful<SiteSettings>,
  locale: Locale
): GlobalNavProps => ({
  globalNavLinks: headerOtherSiteLinks
    ?.filter((globalNavLink) => globalNavLink != null)
    .filter(
      (globalNavLink) =>
        globalNavLink.primaryLink?.url ||
        globalNavLink.primaryLink?.internalLink?.url
    )
    .map((globalNavLink) => ({
      ...linkTransform(
        { ...globalNavLink?.primaryLink },
        locale,
        isRtlLocale(locale) ? <ArrowLeft /> : <ArrowRight />
      ),
    })) as GlobalNavLinkProps[],
  globalNavDropdownTrigger: {
    ariaHasPopUp: true,
    iconBefore: <Bento />,
    title: headerOtherSiteLinks?.[0]?.primaryLink?.title as string,
  },
});

export default globalNavTransform;
